<template>
  <div class="app-container dashboard-client-detail">
    <!-- 筛选栏 -->
    <!-- <div class="filter-container">
      <el-form :inline="true" size="small">
        <el-form-item label="订单时间">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="{
              shortcuts: [
                {
                  text: '近7天',
                  onClick(p) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                    p.$emit('pick', [start, end])
                  },
                },
                {
                  text: '近30天',
                  onClick(p) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                    p.$emit('pick', [start, end])
                  },
                },
                {
                  text: '本月',
                  onClick(p) {
                    const end = new Date()
                    const start = new Date(end.getFullYear(), end.getMonth(), 1)
                    p.$emit('pick', [start, end])
                  },
                },
              ],
            }"
          />
        </el-form-item>
        <el-form-item label="下游客户">
          <el-select
            v-model="listQuery.app_client_id"
            placeholder="全部客户"
            style="width: 150px"
            clearable
            filterable
          >
            <el-option label="全部客户" value="" />
            <el-option
              v-for="client in appClientList"
              :key="client.id"
              :label="client.name"
              :value="client.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <!-- 客户明细表 -->
    <el-card shadow="never" class="mb18">
      <div class="cust-toolbar">
        <div class="cust-left">
          <span style="font-size: 14px; font-weight: 600; color: #303133"
            >下游客户明细</span
          >
          <span class="cust-count"
            >共 <b>{{ clients.length }}</b> 家
            <span v-if="isFiltered" style="color: #409eff; font-weight: 600"
              >（筛后 {{ filteredClients.length }}）</span
            ></span
          >
        </div>
        <div class="cust-right">
          <el-input
            v-model="custSearch"
            placeholder="搜索客户名称"
            size="small"
            style="width: 180px"
            @input="handleCustSearch"
          ></el-input>
          <el-button-group style="margin-left: 10px">
            <el-button
              :type="clientQuickFilter === 'all' ? 'primary' : 'default'"
              size="small"
              @click="clientQuickFilter = 'all'"
              >全部</el-button
            >
            <el-button
              :type="clientQuickFilter === 'txn' ? 'primary' : 'default'"
              size="small"
              @click="clientQuickFilter = 'txn'"
              >有交易</el-button
            >
            <el-button
              :type="clientQuickFilter === 'risk' ? 'danger' : 'default'"
              size="small"
              @click="clientQuickFilter = 'risk'"
              >风险客户</el-button
            >
          </el-button-group>
        </div>
      </div>
      <el-table
        class="desktop-only"
        :data="paginatedClients"
        border
        size="small"
        :header-cell-style="{
          background: '#fafafa',
          color: '#909399',
          fontWeight: 500,
        }"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="#"
          width="45"
          align="center"
        ></el-table-column>
        <el-table-column label="健康度" width="90" align="center">
          <template slot-scope="scope">
            <span
              :style="{
                color: getHealthColor(scope.row.health),
                fontWeight: 700,
              }"
              >{{ scope.row.healthTxt }}({{ scope.row.score }})</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="客户名称"
          min-width="130"
        ></el-table-column>
        <el-table-column
          prop="cid"
          label="客户ID"
          width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="today"
          label="今日营业额"
          width="110"
          sortable
          sort-by="todaySalesValue"
        ></el-table-column>
        <el-table-column
          prop="yest"
          label="昨日营业额"
          width="110"
          sortable
          sort-by="yesterdaySalesValue"
        ></el-table-column>
        <el-table-column
          prop="total"
          label="累计营业额"
          width="120"
          sortable
          sort-by="totalSalesValue"
        ></el-table-column>
        <el-table-column label="复购占比" width="120" align="center">
          <template slot-scope="scope">
            <span
              :style="{
                color:
                  scope.row.repTxt === '—'
                    ? '#909399'
                    : getRateClass(scope.row.rep, 'rep'),
                fontWeight: 700,
              }"
              >{{ scope.row.repTxt }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="today_order_num"
          label="今日单量"
          width="80"
          sortable
        ></el-table-column>
        <el-table-column
          prop="totalOrders"
          label="累计单量"
          width="92"
          sortable
        ></el-table-column>
        <el-table-column prop="refund" label="退单率" width="70" sortable>
          <template slot-scope="scope">
            <span
              :style="{
                color: getRateClass(scope.row.refund, 'refund'),
                fontWeight: 700,
              }"
              >{{ scope.row.refund }}%</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="success" label="预订成功率" width="110" sortable>
          <template slot-scope="scope">
            <span
              :style="{
                color: getRateClass(scope.row.success, 'success'),
                fontWeight: 700,
              }"
              >{{ scope.row.success }}%</span
            >
          </template>
        </el-table-column>
        <el-table-column label="客单价" width="80" sortable sort-by="adrValue">
          <template slot-scope="scope"> ¥{{ scope.row.adr }} </template>
        </el-table-column>
      </el-table>
      <div class="mobile-card-list">
        <div v-if="!paginatedClients.length" class="mobile-card-empty">
          无匹配客户
        </div>
        <article
          v-for="client in paginatedClients"
          :key="client.cid"
          class="mobile-card"
        >
          <div class="mobile-card__top">
            <div class="mobile-card__title">
              <i
                class="mobile-card__dot"
                :style="{ background: getHealthColor(client.health) }"
              ></i>
              <span class="mobile-card__name">{{ client.name }}</span>
              <span class="mobile-card__id">ID {{ client.cid }}</span>
            </div>
            <span
              class="mobile-card__badge"
              :style="{
                color: getHealthColor(client.health),
                borderColor: getHealthColor(client.health),
              }"
            >{{ client.healthTxt }}({{ client.score }})</span>
          </div>
          <div class="mobile-card__metrics">
            <div class="mobile-card__metric">
              <div class="mobile-card__label">今日营业额</div>
              <div class="mobile-card__value">{{ client.today }}</div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">昨日营业额</div>
              <div class="mobile-card__value">{{ client.yest }}</div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">累计营业额</div>
              <div class="mobile-card__value">{{ client.total }}</div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">客单价</div>
              <div class="mobile-card__value">¥{{ client.adr }}</div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">今日单量</div>
              <div class="mobile-card__value">{{ client.today_order_num }}</div>
            </div>
            <div class="mobile-card__metric">
              <div class="mobile-card__label">累计单量</div>
              <div class="mobile-card__value">{{ client.totalOrders }}</div>
            </div>
          </div>
          <div class="mobile-card__footer">
            <span>复购 <b :style="{ color: getRateClass(client.rep, 'rep') }">{{ client.repTxt }}</b></span>
            <span>退单率 <b :style="{ color: getRateClass(client.refund, 'refund') }">{{ client.refund }}%</b></span>
            <span>成功率 <b :style="{ color: getRateClass(client.success, 'success') }">{{ client.success }}%</b></span>
          </div>
        </article>
      </div>
      <mobile-pager
        :current-page="currentPage"
        :total="filteredClients.length"
        :page-size="pageSize"
        @change="currentPage = $event"
      />
      <div class="desktop-pagination">
        <span style="font-size: 12px; color: #909399"
          >共 {{ filteredClients.length }} 条 &nbsp; {{ pageSize }}条/页</span
        >
        <el-pagination
          layout="prev, pager, next, jumper"
          :total="filteredClients.length"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          small
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import MobilePager from '@/components/MobilePager.vue'

export default {
  name: 'DashboardClientDetail',
  components: { MobilePager },
  data() {
    return {
      listQuery: {
        app_client_id: '',
        start_at: '',
        end_at: '',
        quick_filter: 'all',
        name: '',
      },
      dateArr: null,
      appClientList: [],
      clients: [],
      filteredClients: [],
      custSearch: '',
      clientQuickFilter: 'all', // all=查询(全部) / txn=有交易 / risk=风险客户
      currentPage: 1,
      pageSize: 10,
    }
  },
  computed: {
    paginatedClients() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filteredClients.slice(start, end)
    },
    isFiltered() {
      return (
        this.custSearch ||
        this.listQuery.app_client_id ||
        this.dateArr ||
        this.clientQuickFilter !== 'all'
      )
    },
  },
  watch: {
    clientQuickFilter(val) {
      this.listQuery.quick_filter = val
      this.currentPage = 1
      this.fetchClients()
    },
  },
  created() {
    this.getAppClientList()
    this.fetchClients()
  },
  methods: {
    fetchClients() {
      request({
        url: '/api/backend/dataCount/appClientList',
        method: 'get',
        params: { ...this.listQuery, limit: 500 },
      }).then((response) => {
        const payload = response.data || {}
        const list = Array.isArray(payload) ? payload : payload.data || []
        this.clients = list.map(this.normalizeClient)
        this.applyLocalFilters()
      })
    },

    normalizeClient(client) {
      const todaySales = parseFloat(client.today_sales) || 0
      const yesterdaySales = parseFloat(client.yesterday_sales) || 0
      const totalSales = parseFloat(client.sales) || 0
      const totalOrders = parseInt(client.order_num || 0, 10)
      const adrValue = totalOrders > 0 ? totalSales / totalOrders : 0
      const refund =
        parseFloat(client.refund_order_rate ?? client.refund_rate ?? 0) || 0
      const success = parseFloat(client.booking_success_rate || 0) || 0
      const hasRepurchaseRate =
        client.repurchase_rate !== undefined &&
        client.repurchase_rate !== null &&
        client.repurchase_rate !== ''
      const rep = parseFloat(client.repurchase_rate || client.rep || 0) || 0
      const health = this.scoreClient({
        ...client,
        refund_order_rate: refund,
        booking_success_rate: success,
        hasRepurchaseRate,
        repurchase_rate: rep,
      })

      return {
        ...client,
        cid: client.id,
        todaySalesValue: todaySales,
        yesterdaySalesValue: yesterdaySales,
        totalSalesValue: totalSales,
        today: '¥' + this.formatMoney(todaySales),
        yest: '¥' + this.formatMoney(yesterdaySales),
        total: '¥' + this.formatMoney(totalSales),
        totalOrders,
        refund,
        success,
        rep,
        repTxt: hasRepurchaseRate ? rep + '%' : '—',
        adrValue,
        adr: this.formatMoney(adrValue),
        health,
        healthTxt: health.txt,
        score: health.score,
      }
    },

    applyLocalFilters() {
      const keyword = this.custSearch.trim().toLowerCase()
      const list = keyword
        ? this.clients.filter((client) =>
            String(client.name || '')
              .toLowerCase()
              .includes(keyword),
          )
        : this.clients
      this.filteredClients = list
      this.currentPage = 1
    },

    getAppClientList() {
      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: { limit: 500 },
      }).then((response) => {
        this.appClientList = response.data.data || []
      })
    },

    scoreClient(c) {
      let score = 0
      const success = parseFloat(c.booking_success_rate) || 0
      if (success >= 98) score += 40
      else if (success >= 95) score += 32
      else if (success >= 90) score += 24
      else if (success >= 85) score += 16

      const refund = parseFloat(c.refund_order_rate ?? c.refund_rate ?? 0) || 0
      if (refund <= 3) score += 30
      else if (refund <= 5) score += 24
      else if (refund <= 8) score += 18
      else if (refund <= 12) score += 12
      else if (refund <= 15) score += 6

      if (c.hasRepurchaseRate === false) {
        score += 12
      } else {
        const rep = parseFloat(c.repurchase_rate) || 0
        if (rep >= 30) score += 20
        else if (rep >= 15) score += 16
        else if (rep >= 5) score += 12
        else if (rep >= 1) score += 8
        else if (rep > 0) score += 4
      }

      if ((c.today_order_num || 0) > 0) score += 10

      let txt, cls
      if (score >= 85) {
        txt = '优秀'
        cls = 'green'
      } else if (score >= 60) {
        txt = '关注'
        cls = 'orange'
      } else {
        txt = '高风险'
        cls = 'red'
      }

      return { score, txt, cls }
    },

    getHealthColor(health) {
      if (!health) return '#909399'
      if (health.cls === 'green') return '#67C23A'
      if (health.cls === 'orange') return '#E6A23C'
      return '#F56C6C'
    },

    getRateClass(val, kind) {
      const v = parseFloat(val) || 0
      if (kind === 'refund') {
        // 退单率（越低越好）≤8% 绿 / ≤15% 橙 / >15% 红
        if (v <= 8) return '#67C23A'
        if (v <= 15) return '#E6A23C'
        return '#F56C6C'
      }
      if (kind === 'success') {
        // 预订成功率（越高越好）≥95% 绿 / ≥85% 橙 / <85% 红
        if (v >= 95) return '#67C23A'
        if (v >= 85) return '#E6A23C'
        return '#F56C6C'
      }
      if (kind === 'rep') {
        // 复购占比（越高越好）≥15% 绿 / ≥5% 橙 / <5% 红
        if (v >= 15) return '#67C23A'
        if (v >= 5) return '#E6A23C'
        return '#F56C6C'
      }
      return ''
    },

    handleFilter() {
      if (this.dateArr) {
        this.listQuery.start_at = this.dateArr[0] + ' 00:00:00'
        this.listQuery.end_at = this.dateArr[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
      this.currentPage = 1
      this.fetchClients()
    },

    handleReset() {
      this.dateArr = null
      this.custSearch = ''
      this.listQuery = {
        app_client_id: '',
        start_at: '',
        end_at: '',
        quick_filter: 'all',
        name: '',
      }
      this.currentPage = 1
      if (this.clientQuickFilter !== 'all') {
        this.clientQuickFilter = 'all'
      } else {
        this.fetchClients()
      }
    },

    filterClients() {
      this.applyLocalFilters()
    },

    handleCustSearch() {
      this.listQuery.name = this.custSearch
      this.applyLocalFilters()
    },

    formatMoney(val) {
      return parseFloat(val || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-client-detail {
  .mb18 {
    margin-bottom: 18px;
  }

  .filter-container {
    background: #fff;
    border-radius: 6px;
    padding: 16px 20px;
    margin-bottom: 18px;
    border: 1px solid #eef1f6;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06),
      0 6px 18px rgba(16, 24, 40, 0.05);
  }

  .cust-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .cust-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .cust-count {
    color: #909399;
    font-size: 13px;
    b {
      color: #303133;
    }
  }
  .cust-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .tag-red {
    color: #f56c6c;
    background: #fef0f0;
    border: 1px solid #fde2e2;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 700;
  }
  .tag-green {
    color: #67c23a;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 700;
  }
  .tag-orange {
    color: #e6a23c;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 11px;
    font-weight: 700;
  }

  ::v-deep .el-table {
    border-radius: 10px;
    overflow: hidden;
  }
  ::v-deep .el-table th {
    background: #f7f9fc !important;
    color: #5b6472;
    font-weight: 600;
  }
  ::v-deep .el-table--border {
    border: 1px solid #eef1f6;
  }
  ::v-deep .el-table .el-table__body tr:hover > td {
    background: #f5f9ff !important;
  }

  .desktop-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
  }

  .mobile-card-list {
    display: none;
  }

  @media (max-width: 768px) {
    .desktop-only,
    .desktop-pagination {
      display: none !important;
    }

    .mobile-card-list {
      display: block;
    }

    .mobile-card {
      margin-bottom: 10px;
      padding: 12px 14px 10px;
      border: 1px solid #eef1f6;
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
    }

    .mobile-card__top,
    .mobile-card__title {
      display: flex;
      align-items: center;
    }

    .mobile-card__top {
      justify-content: space-between;
    }

    .mobile-card__title {
      min-width: 0;
    }

    .mobile-card__dot {
      flex-shrink: 0;
      width: 8px;
      height: 8px;
      margin-right: 6px;
      border-radius: 50%;
    }

    .mobile-card__name {
      max-width: 42vw;
      overflow: hidden;
      color: #1f2733;
      font-size: 15px;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .mobile-card__id {
      flex-shrink: 0;
      margin-left: 6px;
      color: #8a94a6;
      font-size: 11px;
    }

    .mobile-card__badge {
      flex-shrink: 0;
      margin-left: 6px;
      padding: 2px 8px;
      border: 1px solid;
      border-radius: 20px;
      background: #fff;
      font-size: 11px;
      font-weight: 700;
      white-space: nowrap;
    }

    .mobile-card__metrics,
    .mobile-card__footer {
      display: flex;
      flex-wrap: wrap;
    }

    .mobile-card__metric {
      flex: 0 0 50%;
      box-sizing: border-box;
      padding: 6px 12px 4px 0;
    }

    .mobile-card__label {
      margin-bottom: 1px;
      color: #8a94a6;
      font-size: 11px;
    }

    .mobile-card__value {
      color: #1f2733;
      font-size: 15px;
      font-weight: 700;
      line-height: 1.25;
      word-break: break-all;
    }

    .mobile-card__footer {
      margin-top: 6px;
      padding-top: 8px;
      border-top: 1px dashed #eef1f6;
      color: #606266;
      font-size: 11px;
      line-height: 1.9;
    }

    .mobile-card__footer span {
      margin-right: 14px;
    }

    .mobile-card__footer b {
      font-weight: 700;
    }

    .mobile-card-empty {
      padding: 26px 0;
      color: #909399;
      font-size: 13px;
      text-align: center;
    }

    .cust-toolbar,
    .cust-left,
    .cust-right {
      flex-wrap: wrap;
    }

    .cust-left > *,
    .cust-right > * {
      margin-bottom: 6px;
    }
  }
}
</style>
